import React from 'react';
import {
    Page,
    Card,
    Link,
    Icon,
    Button,
    Layout,
    Stack,
    TextStyle
} from '@shopify/polaris';
import {
    TickMinor
} from '@shopify/polaris-icons';
import { Helmet } from 'react-helmet';
import { apiFetch as fetch } from '../common/Helpers';
import { AppContext } from '../common/AppContext';

const PlanMap = {
    "Basic Shopify": "PlanBasicShopify",
    "Shopify": "PlanShopify",
    "Advanced Shopify": "PlanAdvancedShopify",
    "Shopify Plus": "PlanShopifyPlus",
}

const PlanPricing = {
    "PlanBasicShopify": 9,
    "PlanShopify": 15,
    "PlanAdvancedShopify": 30,
    "PlanShopifyPlus": 50,
}

class ChoosePlanPage extends React.Component {

    state = {
        storeInfo: {}
    };

    renderNew() {
        const defaultPlan = "PlanShopify";
        let selectedPlan = PlanMap[this.context.shopifyPlan];



        if (selectedPlan == null) {
            selectedPlan = defaultPlan;
        }

        var priceText = `Subscribe for $${PlanPricing[selectedPlan]}/month with 14-day free trial`;

        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Start Free Trial</title>
                </Helmet>
                <Page title="Start Free Trial">
                    <Layout>
                        <Layout.Section>
                            <Card title="Subscribe with 14-day Free Trial">
                                <Card.Section>
                                    <p>Tag Genie requires a subscription but all subscriptions includes a 14-day free trial.</p>
                                    <div>
                                        <ul>
                                            <li>You will not be charged before the free trial expires</li>
                                            <li>You can cancel at any time by uninstalling the app</li>
                                            <li>The subscription is on a monthly basis - no long-term commitment from your side.</li>
                                            <li>You can contact our support in case you would like to extend the trial</li>
                                            <li>Subscription is handled by Shopify - you are protected</li>
                                        </ul>
                                    </div>
                                    <div>We have preselected the <b>{`$${PlanPricing[selectedPlan]}/month plan`}</b> based on your Shopify plan.</div>
                                    <p>If you feel that the pricing plan is not appropriate please <Button plain onClick={this.onOpenChat}>chat with us</Button> or reach us at <Link url='mailto:support@taggenieapp.com'>support@taggenieapp.com</Link>.</p>
                                    <p>We also encourage you to checkout our <Link external={true} url='https://taggenieapp.com/pricing'><b>Feels Good</b> pricing policy.</Link></p>
                                    <br />
                                    <div>
                                        <Button primary={true} onClick={() => this.handleSubscribe(selectedPlan)}>{priceText}</Button>
                                    </div>
                                    <br />
                                    <p><TextStyle variation="subdued">After you click the button you will be redirected to the Shopify app subscription page to accept the subscription with free trial.</TextStyle></p>

                                </Card.Section>
                            </Card>
                        </Layout.Section>
                        <Layout.Section secondary>
                            <Card title="What You Get" sectioned>
                                <Stack vertical spacing="tight">
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>14-day trial</p>
                                        </Stack>
                                    </Stack.Item>
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>The Best Tag Management App</p>
                                        </Stack>
                                    </Stack.Item>
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>Auto tagging functionality</p>
                                        </Stack>
                                    </Stack.Item>
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>Bulk editing functionality</p>
                                        </Stack>
                                    </Stack.Item>
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>Unlimited operations</p>
                                        </Stack>
                                    </Stack.Item>
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>All features</p>
                                        </Stack>
                                    </Stack.Item>
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>Premium support</p>
                                        </Stack>
                                    </Stack.Item>
                                </Stack>
                            </Card>
                        </Layout.Section>
                    </Layout>
                </Page>
            </div>
        );
    }

    renderDefault() {

        const defaultPlan = "PlanShopify";
        let selectedPlan = PlanMap[this.context.shopifyPlan];

        if (selectedPlan == null) {
            selectedPlan = defaultPlan;
        }

        var priceText = `Subscribe for $${PlanPricing[selectedPlan]}/month with 14-day trial`;
        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Plan & Features</title>
                </Helmet>
                <Page title="Tag Genie Subscription Plan">
                    <Layout>
                        <Layout.Section>
                            <Card title="What You Get" sectioned>
                                <Stack vertical spacing="tight">
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>14-day trial</p>
                                        </Stack>
                                    </Stack.Item>
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>Best Tag Management App for Shopify</p>
                                        </Stack>
                                    </Stack.Item>
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>Unlimited operations</p>
                                        </Stack>
                                    </Stack.Item>
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>All features</p>
                                        </Stack>
                                    </Stack.Item>
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>Premium support</p>
                                        </Stack>
                                    </Stack.Item>
                                </Stack>
                                <br />
                                <p>For detailed list of all features and pricing information please visit our <Link url="https://taggenieapp.com/pricing">Pricing page</Link></p>
                            </Card>
                            <Card title="Subscribe">
                                <Card.Section>
                                    <div>
                                        <Button primary={true} onClick={() => this.handleSubscribe(selectedPlan)}>{priceText}</Button>
                                    </div>
                                    <br />
                                    <p>We also encourage you to checkout our <Link external={true} url='https://taggenieapp.com/pricing'><b>Feels Good</b> pricing policy.</Link></p>
                                    <p>If you feel that the pricing plan is not appropriate please <Button plain onClick={this.onOpenChat}>chat with us</Button> or reach us at <Link url='mailto:support@taggenieapp.com'>support@taggenieapp.com</Link>.</p>

                                </Card.Section>
                            </Card>
                        </Layout.Section>
                    </Layout>
                </Page>
            </div>
        );
    }

    render() {

        const newPage = this.context.cohorts.includes("ImprovedFirstSubscriptionPage");

        if (newPage) {
            return this.renderNew();
        }
        else {
            return this.renderDefault();
        }
    }

    handleSubscribe(planName) {
        fetch(`api/storeConnections/changePlanRequest`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ "planTier": planName })
        }).then(response => response.json())
            .then((data) => {

                if (data.confirmationUrl != null) {
                    window.location.href = data.confirmationUrl;
                }
            });
    }

    onOpenChat = () => {
        window.$crisp.push(["do", "chat:open"]);
    }

    componentDidMount() {
    }
}

ChoosePlanPage.contextType = AppContext;

export default ChoosePlanPage;